
import { Component, Vue } from "vue-property-decorator";
import { ComponentInterface, ShiftType } from "@/services/Dev-scrum/interfaces";
import DevScrumRepository from "@/services/Dev-scrum";
import { ShiftDayType } from "@/services/Calendar/ShiftType/Interfaces";
import CreateAuditForm from "@/services/Dev-scrum/forms/CreateAuditForm";

@Component({
  inject: [
    'devScrumRepository',
  ],
})
export default class CreateAudit extends Vue {
  private readonly devScrumRepository: DevScrumRepository;
  private date: string = new Date().toISOString().substr(0, 10);
  private components: ComponentInterface[] = [];
  private inputRefs: HTMLElement[] = [];
  private errorMessage: string | null = null;
  private submitted = false;
  private cols = 12;
  private md = 3;


  private async created(): Promise<void> {
    await this.initializeComponents();
  }

  private async initializeComponents(): Promise<void> {
    this.components = await this.devScrumRepository.getAllActiveComponents();
  }

  private get shiftOptions() {
    return Object.values(ShiftType).map((value: string) => ({ name: value }));
  }

  private forms = [
    new CreateAuditForm(),
  ];

  private addForm(): void {
    this.forms.push(new CreateAuditForm());

    this.$nextTick(() => {
      const newIndex = this.forms.length - 1;
      const nextInput = this.$refs[`ticket${newIndex}`] as HTMLElement[] | undefined;
      if (nextInput && nextInput.length > 0) {
        nextInput[0].focus();
      }
    });
  }

  private removeForm(): void {
    if (this.forms.length > 1) {
      this.forms.pop();
    }
  }


  private setInputRef(el: HTMLElement | null, index: number): void {
    if (el) {
      this.$set(this.inputRefs, index, el);
    } else {
      this.inputRefs.splice(index, 1);
    }
  }

  public async submitAudit(): Promise<void> {
    try {
      const newForms = this.forms.map((form) => {
        const baseForm = {
          date: new Date(this.date).toISOString(),
          shift: form.shift || ShiftDayType.WORK,
          componentIds: [],
          ticket: null,
          time: null
        };

        if (form.shift === "WORK" || !form.shift) {
          return {
            ...baseForm,
            componentIds: form.components.map((component) => component),
            ticket: form.ticket.toUpperCase(),
            time: Number(form.time),
          };
        } else {
          return baseForm;
        }
      });

      if (newForms.length === 1) {
        console.log(newForms[0]);
        await this.devScrumRepository.createAudit(newForms[0]);
      } else {
        await this.devScrumRepository.createAudits(newForms);
      }

      this.errorMessage = null;
      this.submitted = true;

      setTimeout(() => {
        this.submitted = false;
        this.resetForm();
      }, 1000);
    } catch (err) {
      console.log(err);
      this.$errorDialog.show(err.response.data.message);
    }
  }


  private picker(val: string) {
    this.date = val;
  }

  private resetForm(): void {
    this.forms = [
      new CreateAuditForm(),
    ];
  }
}

